document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    const currentDetails = event.currentTarget.closest('details');
    event.currentTarget.setAttribute('aria-expanded', !currentDetails.hasAttribute('open'));

    currentDetails.parentElement.querySelectorAll(':scope > [id^="Details-"]').forEach((sibling) => {
      if (sibling !== currentDetails && sibling.hasAttribute('open')) {
        sibling.removeAttribute('open');
        sibling.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      }
    });
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}


function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

(() => {
  const searchButton = document.getElementById('search-button');
  const searchModal = document.querySelector('.search-modal');
  document.addEventListener('keyup', onKeyUp);

  if(searchButton) {
    searchButton.addEventListener('click', () => {
      if (searchModal?.classList.contains('open')) {
        searchModal?.closeModal();
      } else {
        searchModal?.openModal();
      }
    })
  }

  function onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    searchModal?.closeModal();
  }
})()

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    const variantsJson = this.querySelector('[data-product-variants]');
    this.variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
    try {
      this.defaultOptions = JSON.parse(this.dataset.defaultOptions || '[]') || [];
    } catch (error) {
      this.defaultOptions = [];
    }
  }

  connectedCallback() {
    this.updateVariantInput();
    this.updateAvailabilityNotes();

    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);
      this.updateVariantInput();
      this.updateAvailabilityNotes();

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  // Each option's drawer shows, per value, the availability note ("Available
  // now" / delivery lead time) for the variant that value would produce —
  // but since picking an option here never reloads the page, those notes are
  // otherwise frozen at whatever they were server-rendered with. Recompute
  // them after every change: for each candidate value, swap it into the
  // currently selected combination at that option's own position (falling
  // back to the page's default combination for any option not yet chosen)
  // and look up the resulting variant's stock.
  updateAvailabilityNotes() {
    if (!this.variants.length) return;

    const groups = Array.from(this.querySelectorAll('option-selector[data-option-position]'));
    const selected = this.defaultOptions.slice();

    groups.forEach((group) => {
      const index = Number(group.dataset.optionPosition) - 1;
      const checked = group.querySelector('input:checked');
      if (checked) selected[index] = checked.value;
    });

    groups.forEach((group) => {
      const index = Number(group.dataset.optionPosition) - 1;

      group.querySelectorAll('[data-availability-note]').forEach((note) => {
        const input = note.closest('label')?.querySelector('input');
        if (!input) return;

        const candidate = selected.slice();
        candidate[index] = input.value;

        const variant = this.variants.find((v) => v.options.every((option, i) => option === candidate[i]));
        const isAvailableNow = Boolean(variant && variant.inventory_quantity > 0);

        note.textContent = isAvailableNow ? note.dataset.availableText : note.dataset.leadtimeText;
      });
    });
  }

  getSelectedVariant() {
    const selectedValues = Array.from(this.querySelectorAll('option-selector')).map((group) => {
      const checked = group.querySelector('input:checked');
      return checked ? checked.value : undefined;
    });

    return this.variants.find((variant) =>
      variant.options.every((option, index) => option === selectedValues[index])
    );
  }

  updateVariantInput() {
    const productForm = document.querySelector(`product-form[data-section-id="${this.dataset.section}"]`);
    if (!productForm) return;

    const variant = this.getSelectedVariant();
    const input = productForm.querySelector('.product-variant-id');
    if (input) {
      input.value = variant ? variant.id : '';
      input.disabled = !variant || !variant.available;
    }

    const submitButton = productForm.querySelector('[type="submit"]');
    if (submitButton) {
      // Left enabled when no variant is chosen yet (unlike the sold-out
      // case) so a click still reaches ProductForm.onSubmit, which opens
      // the variant drawer instead of submitting.
      submitButton.disabled = variant ? !variant.available : false;

      const label = submitButton.querySelector('[data-submit-button-text]');
      if (label) {
        label.textContent =
          variant && !variant.available ? submitButton.dataset.soldOutText : submitButton.dataset.addToCartText;
      }
    }

    publish(PUB_SUB_EVENTS.variantChange, {
      data: {
        sectionId: this.dataset.section,
        variant,
      },
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    const optionLabel = target.closest('.product-form__input')?.querySelector('.product-option-row__label[data-option-name]');
    if (optionLabel) optionLabel.textContent = optionLabel.dataset.optionName;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], option-selector input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class ProductRecommendations extends HTMLElement {
  observer = undefined;
  limit = 4;

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 0px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}?limit=${this.limit}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

document.addEventListener('DOMContentLoaded', () => {
  const { hash } = window.location;

  // Prevent the browser from instantly jumping to the hash
  if (hash) {
    window.scrollTo(0, 0); // reset scroll position before doing anything
    history.scrollRestoration = 'manual'; // prevents browser auto scroll restore
  }

  // Then smooth scroll to the target after layout is ready
  if (hash) {
    const target = document.querySelector(hash);
    if (target) {
      setTimeout(() => {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }
});

class ProductTemplateImages extends HTMLElement {
  constructor() {
    super();
    this.zoomContainer = this.querySelector('.zoom-container');
    this.scroller = this.querySelector('.zoom-container__inner');
    this.thumbnailList = this.querySelector('#zoom-thumbnnail-list');
    this.thumbButtons = this.querySelectorAll('.thumb-btn');
    this.image = this.querySelectorAll('.product-image');
    this.closeButton = this.querySelector('.zoom-container-close');
    this._isExpanded = false;
    this.swiperContainer = this.querySelector('swiper-container');
    this.bindEvents();
    this.initScrollSpy();
    this.initSwiper();
  }

  bindEvents() {
    if (this.image) {
      this.image.forEach(image => {
        image.addEventListener('click', this.open.bind(this));
      })
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this));
    }

    // CLICK TO SCROLL LOGIC
    this.thumbButtons.forEach(button => {
      const targetImgElement = document.getElementById(button.dataset.targetId)
      button.addEventListener('click', () => {
        this.highlightThumbnail(button.dataset.targetId)
        // Scroll the actual image into view
        targetImgElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    if (this._isExpanded) {
      this.close()
    }
  }

  open() {
    if (this._isExpanded) return;
    this._isExpanded = true;

    document.addEventListener('keyup', this.onKeyUp.bind(this));

    // Save scroll position
    this._scrollY = window.scrollY;

    // Lock scroll
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this._scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';

    // lock scroll
    document.body.classList.add('overflow-hidden');
    this.classList.add('expanded');
    gsap.to(this.zoomContainer, { y: 0, duration: 1, ease: 'expo.inOut' });
  }

  close() {
    if (!this._isExpanded) return;
    this._isExpanded = false;

    document.removeEventListener('keyup', this.onKeyUp.bind(this));

    // Restore scroll lock state
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';

    // Restore scroll position
    window.scrollTo(0, this._scrollY || 0);
    this.classList.remove('expanded');
    document.body.classList.remove('overflow-hidden');

    gsap.to(this.zoomContainer, { y: '100%', duration: 1, ease: 'expo.inOut' });
  }

  initSwiper() {
    this.prevButton = this.querySelector('.product-swiper-prev');
    this.nextButton = this.querySelector('.product-swiper-next');

    const params = {
      injectStyles: [`
      .swiper-pagination-bullet {
        height: 10px;
        text-align: center;
        line-height: 20px;
        font-size: 8.8px;
        color: rgba(190, 190, 190, 1);
        opacity: 1;
        background: none;
        margin: 0 !important;
      }

      .swiper-pagination-bullet-active {
        color: #000;
      }
      `],
      pagination: {
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      },
      navigation: {
        prevEl: this.prevButton,
        nextEl: this.nextButton,
      },
    }

    Object.assign(this.swiperContainer, params)

    this.swiperContainer.initialize();
  }

  /**
   * 4. The Scroll Spy (Intersection Observer)
   */
  initScrollSpy() {
    const zoomedImages = this.scroller.querySelectorAll('.zoom-image');
    // Configuration: Threshold 0.5 means trigger when 50% of image is visible
    const options = {
      root: this.scroller, // The scrollable container
      rootMargin: '0px',
      threshold: 0.5 
    };

    this._observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.highlightThumbnail(entry.target.id);
        }
      });
    }, options);

    // Observe all images in the slot
    zoomedImages.forEach(img => this._observer.observe(img));
  }

  /**
   * Helper to toggle classes
   */
  highlightThumbnail(imageId) {
    const buttons = this.thumbnailList.querySelectorAll('.thumb-btn');

    buttons.forEach(btn => {
      if (btn.dataset.targetId === imageId) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }
}

// PRODUCT CARD SWIPER GALLERY

customElements.define('product-template-images', ProductTemplateImages);